// extracted by mini-css-extract-plugin
export var container = "Sports-module--container--jhs7b";
export var infoContainer = "Sports-module--infoContainer--EbeUu";
export var page = "Sports-module--page--DSmfs";
export var slide = "Sports-module--slide--QCgI3";
export var swiperSlide = "Sports-module--swiper-slide--nnw5k";
export var wrapper = "Sports-module--wrapper--wI2zc";